import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NavLink, Outlet } from 'react-router-dom';
import s from './Settings.module.css';
import { Icon } from '@/components/Icon';
const TABS = [
    { to: 'general', icon: 'sliders', label: 'General' },
    { to: 'storages', icon: 'cloud', label: 'Storages' },
    { to: 'notifications', icon: 'bell', label: 'Notifications' },
    // Metadata DB self-backup config — endpoint/creds read-only (env-managed),
    // interval editable. See backend api/system.py and tasks/self_backup.py.
    { to: 'meta-backup', icon: 'shield', label: 'Meta backup' },
    { to: 'security', icon: 'lock', label: 'Security' },
    { to: 'about', icon: 'info', label: 'About' },
];
export function Settings() {
    return (_jsxs("div", { children: [_jsx("h1", { className: s.h1, children: "Settings" }), _jsx("div", { className: s.h1Sub, children: "Service configuration" }), _jsxs("div", { className: s.root, children: [_jsx("nav", { className: s.subnav, children: TABS.map((t) => (_jsxs(NavLink, { to: t.to, className: ({ isActive }) => `${s.item} ${isActive ? s.active : ''}`, children: [_jsx(Icon, { name: t.icon, size: 16 }), _jsx("span", { children: t.label })] }, t.to))) }), _jsx("div", { className: s.content, children: _jsx(Outlet, {}) })] })] }));
}
